
import Gallery from "./elements/gallery";
import Offers from "./elements/offers";
import Header from './components/header';
import ModuleFactory from "./util/module-factory";
import Rooms from "./elements/rooms";
import Cards from "./elements/cards";
import ThingsToDo from "./elements/things-to-do";
import Reviews from "./elements/reviews";
import Form from "./elements/form";
import Blog from "./components/blog";
import Tel from "./components/tel";
import SubscribeForm from "./elements/subscribe-form";
import Faq from "./elements/faq";

const modules = [
	Cards,
	Header,
	ThingsToDo,
	Reviews,
	Rooms,
	Gallery,
	Offers,
	Form,
	Blog,
	Tel,
	SubscribeForm,
	Faq,
];

new ModuleFactory(modules);
